import script from "./FileGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./FileGallery.vue?vue&type=script&setup=true&lang=js"

import "./FileGallery.vue?vue&type=style&index=0&id=b593b78c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b593b78c"]])

export default __exports__